<template>
  <div style="margin-bottom: 30px">
    <div class="title-block">号車の指定</div>
    <p class="text-block">
      ※選択された号車または座席で確保されない場合があります
    </p>
    <div class="column">
      <div class="field">
        <div class="select-wrap">
          <select v-model="selectedCar">
            <option>指定しない</option>
            <template v-for="(car, index) in props.cars">
              <option
                v-if="!car.is_exclusive"
                :key="index"
                :value="car"
              >
                {{ car.number }}号車
              </option>
            </template>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";
import { useVModel } from "vue-composable";

export default {
  name: "MFITTBookingSelectCarNumber",
  props: {
    cars: {
      type: Array,
      required: true,
    },
    selectedCar: {
      required: true,
    },
  },
  setup(props) {
    const selectedCar = useVModel(props, "selectedCar");

    return {
      props,
      selectedCar,
    };
  },
};
</script>

<style lang="scss" scoped>
.title-block {
  margin: 20px 6px 8px;
  font-size: 13px;
  text-align: left;
  line-height: 17px;
  font-weight: bold;
}

.text-block {
  margin: 10px 6px;
  font-size: 12px;
  color: #ed2323;
}

.column .error-block {
  margin: 10px 0;
  font-size: 13px;
  font-weight: bold;
  text-align: right;
  line-height: 17px;
  color: #ff3333;
}

.column {
  margin-bottom: 16px;
  margin-top: 0;
}
.field {
  position: relative;
  margin: 0 0 0 0;
}
/* セレクトボックス */
select {
  -webkit-appearance: none;
  width: 100%;
  height: 42px;
  margin-bottom: 0;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background-color: #ffffff;
  outline: none;
  padding: 12px 10px 12px 150px;
  font-size: 14px;
  line-height: 14px;
  font-weight: bold;
  color: #000000;
}

select:focus {
  border-color: #e0e0e0;
}

.select-wrap {
  width: 100%;
  position: relative;
  display: inline-block;
  border-radius: 6px;
}

.select-wrap::after {
  content: "";
  width: 6px;
  height: 6px;
  border: 0px;
  border-bottom: solid 2px #b4b3b3;
  border-right: solid 2px #b4b3b3;
  -ms-transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  position: absolute;
  top: 20px;
  right: 15px;
  margin-top: -4px;
}
</style>
